<template>
  <div class="not-found">
    <div class="inner-wrapper">
      <img src="@/assets/images/logo-404-new.png" alt="error image" />

      <div class="container text-center">
        <h1 class="main-text-color">{{ $t("page_not_found") }}</h1>
        <router-link :to="redirectTo"
          ><el-button class="btn-primary">{{
            $t("go_back_to_home_page")
          }}</el-button></router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",

  computed: {
    userRoleId() {
      return this.$store.state.user.roleId;
    },

    redirectTo() {
      if (this.userRoleId === 4 || this.userRoleId === 6 || this.userRoleId === 3 || this.userRoleId === 7 || this.userRoleId === 1 || this.userRoleId === 2) {
        return "/dashboard";
      } else {
        return "/my-presence";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables";

body {
  background-color: #5a657a !important;
  color: white;
  font-family: "Roboto", sans-serif;

  h1 {
    margin-bottom: 20px;
  }

  p {
    font-size: 18px;
    line-height: 30px;
  }

  a {
    color: #fbd160;
  }
}
.not-found {
  background-image: url("@/assets/images/absent-bg.jpg");
  background-size: cover;
  background-position: 50% 50%;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
}
.inner-wrapper {
  text-align: center;
  img {
    max-width: 250px;
  }
}
</style>
